import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../fonts/PPNeueMontrealText-Variable.woff2%22}],%22variableName%22:%22ppNeueMontrealText%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ppNeueMontrealText', 'ppNeueMontrealText Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
